import './index.less';

import React, { useEffect, useState } from 'react';
import type { InputValue, SelectValue } from 'tdesign-react';
import { Input, Select } from 'tdesign-react';

import type { ISelectOptions } from './../../interface';

const { Option } = Select;

interface RelationInputProp {
  value?: string;
  onChange: (val: any) => any;
  disabled?: boolean;
  options?: ISelectOptions[];
  type?: 'kv' | 'comb';
  clearable?: boolean;
}

export const RelationInput: React.FC<RelationInputProp> = (props) => {
  const { type = 'kv', options = [] } = props;

  const [compVal, setCompVal] = useState<any>(() => {
    const { value = { [options[0].value]: undefined } } = props;
    const compValue = Object.entries(value)[0];
    return {
      key: compValue[0],
      value: compValue[1],
    };
  });

  useEffect(() => {
    if (type === 'kv') {
      props.onChange({ [compVal.key]: compVal.value });
    }
  }, [compVal.key, compVal.value]);

  const handleChange = (key: SelectValue, value: InputValue) => {
    setCompVal({
      key,
      value,
    });
  };

  return (
    <Input.Group className={'relationInput'}>
      <Select defaultValue={compVal.key} onChange={key => handleChange(key, compVal.value)} className={'selectWrap'}>
        {options?.map((item, i) => (
          <Option key={i} value={item.value} disabled={item.disabled}>
            {item.label}
          </Option>
        ))}
      </Select>
      <Input
        autoWidth
        defaultValue={compVal.value}
        onChange={val => handleChange(compVal.key, val)}
        clearable={props.clearable}
      />
    </Input.Group>
  );
};
